import React from 'react'
import { Grid, GridItem } from '@deal/components'
import styles from './styles.css'

interface PageContentProps extends React.HTMLAttributes<HTMLDivElement> {}

const PageContent: React.SFC<PageContentProps> = ({ children, ...rest }) => {
  return (
    <Grid {...rest} className={styles.fullWidth}>
      <GridItem col={2} {...rest}>
        {children}
      </GridItem>
    </Grid>
  )
}

export default PageContent
